<template>
  <div class="content">
    <h3>医保、药价改革：将致医药行业增速放缓、毛利降低</h3>
    <p>瑞银研究认为，医保、药价体系改革是2016-2017年的主旋律，其将导致医药行业增速放缓、毛利率长期降低。</p>
    <p>因政府密集发布医改政策，2016-2017年被称为医政大年。业内总结，医改政策主要集中于医保及定价体系，两者将对医药行业产生深远影响。</p>
    <p>3月13日，瑞银为此召开专题研究，结论为，医保控费将导致医药行业增速放缓；药价改革将导致行业毛利率长期下降。</p>
    <p>但这一深远影响目前尚未显现，2016年，中国医药行业收入2.8万亿元，同比增长9.7%；利润3002亿元，同比增长13.9%。</p>
    <p>“此次改革的出发点是结构调整，并不是以前的大幅增加投入，而是一部分人受益、一部分人中性、另一部分人可能受损。”瑞银证券医药行业分析师赵冰认为：“医药行业不会像刚开始医改时每年有百分之二三十的增长，现在处于下滑的台阶。”</p>
    <p class="strong">控费致行业增速放缓</p>
    <p>医保控费的苗头始于2010年后，从2011年起，部分地区如上海医保从开源向节流转变。2013年，医保基金出现收入增速低于支出增速的局面，面临结余收窄甚至“收不抵支”。至2015年，医保基金的收入和支出增速分别下降到15.55%和14.48%。与此同时，招标降价、医保控费变为行业常态。</p>
    <p>“医保控费会导致医药行业收入增长放缓。”赵冰解释，2009年以来，医改的主要成绩是政府增加支出，驱动医药行业增长，并建立起全面覆盖及可负担的医疗费用。</p>
    <p>而新的矛盾在于GDP增速下滑后，医药行业持续投入压力加大，赵冰认为，“在医保支出增速高于筹资增速的局面下，为维持医保基金的收支平衡，控费将在长期成为医保改革的核心。目前，医药行业、医保改革实质上是通过需求端结构调整控制医疗费用增长。”</p>
    <p>“2011-2015年，制药行业收入实现了15%的年复合增长。但我们预计，未来三年制药行业的收入增速将放缓至10%。”赵冰补充。</p>
    <p>另外，新版医保目录药品数量增加带来的红利不如想象中大，2月23日人社部印发《国家基本医疗保险、工伤保险和生育保险药品目录（2017年版）》，西药、中成药共收载药品2535个，较2009年版目录新增339个，增幅约15%。</p>
    <p>“但在医保支付价制约下，多数品种不会出现2009版目录实行后的放量猛涨局面。”独角兽工作室创始人刘谦对21世纪经济报道记者表示，“新版目录扩容暗示了结构调整和控费手段将继续实施，医保目录的最大受益者是患者而不是药企。”</p>
    <p class="strong">药价改革致毛利长期下降</p>
    <p>1月6日，国家卫计委主任李斌在“全国卫生计生工作会议”上表示，2017年要全部取消药品加成。国务院医改办主任王贺胜在3月11日的记者会上再次强调了这一政策。</p>
    <p>王贺胜表示：“这意味着我国公立医疗机构将彻底告别‘以药补医’时代。改革前，公立医院是通过服务收费、药品加成收入和政府补贴这三个补助渠道。改革后，我们就取消了药品加成，变成了服务收费和政府补助两个渠道。”</p>
    <p>上述改革将直接影响药品价格，此外，招投标、医保支付体系改革也将对药价产生巨大影响。</p>
    <p>瑞银研报分析，医院和医保部门将更多参与药价制定过程；医保支付价将取代招标价；医院采购前招标价将有更多调整。</p>
    <p>药价下滑的后果是降低医药行业的毛利率。赵冰表示，“药价改革的目的是，形成一个确保药价可承受，并兼顾药企积极性的定价体系。目前药品定价越来越呈现出二元定价体系，即价格由招标和医保支付共同决定。”</p>
    <p>根据上述报告，此前药品最低价普遍出现在2015、2016年，这意味着近几轮招标价格呈现明显下降趋势。中国医药行业前三个5年期的毛利率分别为35%（1999-2003）、31%（2004-2009）和29%（2010-2015）。毛利率整体呈现下滑趋势，主要是由于劳动力和生产成本等上升，受到药价进一步走低影响，瑞银预计，毛利率下行趋势将在下一个5年期延续。</p>
    <p>近期舆论热议福建等地出台的医保支付结算限价，会对原研药厂家产生较大影响，“这未必是一件坏事，很多在中国使用的原研药都是过期的，只有过期的原研药才会有这种顾虑和担忧，”赵冰对21世纪经济报道记者表示，“价格过高对医保资金的占用比例非常大，通常是在糖尿病、高血压等大病种领域。但其实国内已经有很好的仿制药上市，凭什么我们还需要给过期原研药制定更高价格呢？”</p>
  </div>
</template>

<script>
export default {
  name: 'TabHealthcareReform'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  h3{
    font-size: 20px;
    color: #000000;
    font-weight: 700;
    text-align: center;
    margin: 20px;
  }
  p{
    font-size: 18px;
    line-height: 36px;
    text-indent:40px;
  }
  .strong{
    color: #434343;
    font-size: 20px;
    font-weight: 700;
  }
}
</style>
